import { type DietaryPreferencesTypes } from '../setup';

// ─────────────────────────────────────────────────────────────────────────────

export function checkIfHasSelectedPreferences(preferences: DietaryPreferencesTypes) {
  return Object.values(preferences).some(Boolean);
}
